module.exports = __webpack_public_path__ + "img/quanjingditu.efb63329.png";